import React from 'react';
import { motion } from 'framer-motion';
import Logger from '../utils/logger';
import './Footer.css'; // Import du nouveau fichier CSS

// Constants pour les liens
const SOCIAL_LINKS = [
    {
        href: "https://x.com/TheGr33dyzClub",
        label: "Twitter",
        icon: "𝕏"
    },
    {
        href: "https://t.me/+ST4-blQBoLs5NWI8",
        label: "Telegram FR",
        icon: "🇫🇷"
    },
    {
        href: "https://t.me/+WipDE7pBxF41Mzc0", 
        label: "Telegram EN",
        icon: "🇬🇧"
    },
    {
        href: "https://github.com/Foxocelot45/GR33D-TOKEN",
        label: "GitHub",
        icon: "📦"
    },
    {
        href: "https://discord.gg/FPGyuKxJx6",
        label: "Discord",
        icon: "💬"
    }
];

// Animations variants
const footerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
        opacity: 1, 
        y: 0,
        transition: {
            duration: 0.5,
            ease: "easeOut",
            when: "beforeChildren",
            staggerChildren: 0.1
        }
    }
};

const linkVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
    hover: { y: -3, scale: 1.05, transition: { duration: 0.2 } },
    tap: { scale: 0.95 }
};

const Footer = () => {
    // Handler pour logger les clics sur les liens
    const handleSocialClick = (platform) => {
        Logger.log('footer', 'Social link clicked', {
            platform,
            timestamp: Date.now()
        });
    };

    return (
        <motion.footer 
            className="footer"
            variants={footerVariants}
            initial="hidden"
            animate="visible"
            viewport={{ once: true }}
        >
            <div className="footer-content">
                {/* Social Links */}
                <div className="footer-links">
                    {SOCIAL_LINKS.map(({ href, label, icon }) => (
                        <motion.a
                            key={href}
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            variants={linkVariants}
                            whileHover="hover"
                            whileTap="tap"
                            onClick={() => handleSocialClick(label)}
                        >
                            <span className="link-icon">{icon}</span>
                            <span className="link-label">{label}</span>
                        </motion.a>
                    ))}
                </div>

                {/* Copyright */}
                <motion.div 
                    className="copyright-text"
                    variants={linkVariants}
                >
                    © {new Date().getFullYear()} GR33D Vault Ecosystem - All Rights Reserved
                </motion.div>
            </div>
        </motion.footer>
    );
};

export default React.memo(Footer);
